<template>
    <section class="payApvlRTable">
        <!-- el-table -->
        <el-table ref="multipleTable" :data="tableData" border  style="min-height: 350px;" @selection-change="handleSelectionChange" class="table">
           <el-table-column type="selection" width="55" ></el-table-column>
            <el-table-column align="center" label="雇员编号">
                <el-table-column align="center" prop="empNo" class-name="own-cancal--lh" width='100'>
                    <template slot="header" slot-scope="scope" >
                        <el-input placeholder="关键字筛选" v-model="empNo" @change="handleChangeInputSelect(scope.row.empNo)" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="雇员姓名">
                <el-table-column align="center" prop="empName" class-name="own-cancal--lh" width='100'>
                    <template slot="header" slot-scope="scope">
                        <el-input placeholder="关键字筛选" v-model="empName" @change="handleChangeInputSelect(scope.row.empName)" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="还款金额">
                <el-table-column align="center"  class-name="own-cancal--lh" width='150'>
                    <template slot-scope="scope">{{ scope.row.repaymentAmount +'元' }}</template>
                    <template slot="header" slot-scope="scope">
                        <el-input placeholder="关键字筛选" v-model="repaymentAmount" @change="handleChangeInputSelect(scope.row.repaymentAmount)" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="状态">
                <el-table-column align="center" prop="status" class-name="own-cancal--lh" width='150'>
                    <template slot="header" slot-scope="scope" >
                        <el-select  placeholder="关键字筛选" v-model="status" @change="handleChangeInputSelect(scope.row.status)" clearable>
                            <el-option
                                v-for="item in statusOptions"
                                :key="item.codeItemId"
                                :label="item.codeItemName"
                                :value="item.codeItemId"
                            ></el-option>
                        </el-select>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="雇员证件号">
                <el-table-column align="center" prop="idCard" class-name="own-cancal--lh" width='200'>
                    <template slot="header" slot-scope="scope" >
                        <el-input placeholder="关键字筛选" v-model="idCard" @change="handleChangeInputSelect(scope.row.idCard)" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="雇员邮箱">
                <el-table-column align="center" prop="empEmail" class-name="own-cancal--lh" width='220'>
                    <template slot="header" slot-scope="scope" >
                        <el-input placeholder="关键字筛选" v-model="empEmail" @change="handleChangeInputSelect(scope.row.empEmail)" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="发送次数">
                <el-table-column align="center" prop="sentnums" class-name="own-cancal--lh" width='100'>
                    <template slot="header" slot-scope="scope" >
                        <el-input placeholder="关键字筛选" v-model="sentnums" @change="handleChangeInputSelect(scope.row.sentnums)" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="还款时间">
                <el-table-column align="center" prop="repaymentDate" class-name="own-cancal--lh" width='180'>
                    <template slot="header" slot-scope="scope" >
                        <el-input placeholder="关键字筛选" v-model="repaymentDate" @change="handleChangeInputSelect(scope.row.repaymentDate)" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="公司开户名">
                <el-table-column align="center" prop="companyAccountName" class-name="own-cancal--lh" width='250'>
                    <template slot="header" slot-scope="scope" >
                        <el-input placeholder="关键字筛选" v-model="companyAccountName" @change="handleChangeInputSelect(scope.row.companyAccountName)" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="公司银行账号">
                <el-table-column align="center" prop="companyBankNo" class-name="own-cancal--lh" width='180'>
                    <template slot="header" slot-scope="scope" >
                        <el-input placeholder="关键字筛选" v-model="companyBankNo" @change="handleChangeInputSelect(scope.row.empNo)" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="公司开户行">
                <el-table-column align="center" prop="companyBank" class-name="own-cancal--lh" width='250'>
                    <template slot="header" slot-scope="scope" >
                        <el-input placeholder="关键字筛选" v-model="companyBank" @change="handleChangeInputSelect(scope.row.companyBank)" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="汇款摘要">
                <el-table-column align="center" prop="remitAbstract" class-name="own-cancal--lh" width='250'>
                    <template slot="header" slot-scope="scope" >
                        <el-input placeholder="关键字筛选" v-model="remitAbstract" @change="handleChangeInputSelect(scope.row.remitAbstract)" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="备注" >
                <el-table-column align="center" prop="remark" class-name="own-cancal--lh" width='250'>
                    <template slot="header" slot-scope="scope" >
                        <el-input placeholder="关键字筛选" v-model="remark" @change="handleChangeInputSelect(scope.row.remark)" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="预留列1" >
                <el-table-column align="center" prop="reserveColumnOne" class-name="own-cancal--lh" width='250'>
                    <template slot="header" slot-scope="scope" >
                        <el-input placeholder="关键字筛选" v-model="reserveColumnOne" @change="handleChangeInputSelect(scope.row.remark)" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="预留列2" >
                <el-table-column align="center" prop="reserveColumnTwo" class-name="own-cancal--lh" width='250'>
                    <template slot="header" slot-scope="scope" >
                        <el-input placeholder="关键字筛选" v-model="reserveColumnTwo" @change="handleChangeInputSelect(scope.row.remark)" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" label="预留列3" >
                <el-table-column align="center" prop="reserveColumnThree" class-name="own-cancal--lh" width='250'>
                    <template slot="header" slot-scope="scope" >
                        <el-input placeholder="关键字筛选" v-model="reserveColumnThree" @change="handleChangeInputSelect(scope.row.remark)" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" fixed="right" label="操作">
                <template slot-scope="scope">
                    <!-- slot 删除按钮 -->
                    <slot name="deleteButton" :row="scope.row"></slot>
                </template>
            </el-table-column>
        </el-table>

        <!-- footer pagination -->
        <footer style="margin-top:5px;">
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                @size-change="handleSizeChange"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                background
            ></el-pagination>
        </footer>
    </section>
</template>
<script>

import {
    getloadTaxData
} from "@/api/tesla/debtManagement.js";
export default {
    name: 'payApvlRTable',
    props: {
      change: {
        type: String,
        default: ''
      },
      noCefirm:{
        type: Array,
        default: []
      }
    },
    data() {
        return {
            /** el-table */
            tableData: [],
            currentPage: 1,     // 当前页
            pageSize: 10,       // 条/页
            total: 0,           // 总条目数
            multipleSelection:[],
            companyAccountName: "",
            companyBank: "",
            companyBankNo: "",
            empEmail: "",
            empName: "",
            empNo: "",
            id: "",
            idCard: "",
            remark: "",
            remitAbstract: "",
            repaymentAmount: "",
            repaymentDate: "",
            reserveColumnOne: null,
            reserveColumnThree: null,
            reserveColumnTwo: null,
            sentnums: '',
            status: "",
            statusOptions: [
              { codeItemId: 0, codeItemName: '未发送' },
              { codeItemId: 1, codeItemName: '已发送未确认' },
              { codeItemId: 2, codeItemName: '已确认' },
            ],  // 下拉 状态
        }
    },
    filters:{
        ff:function(v){
            debugger
            console.log(v)
        }
    },
    created() {
        this._getloadTaxData()
    },
    watch: {
        change(){
            this._getloadTaxData()
        },
        noCefirm(){
            if (this.noCefirm.length!=0) {
                this.noCefirm.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        }
    },
    methods: {
         // 初始化数据
        _getloadTaxData() {
            let params = {
                pageNum:'2',
                page: this.currentPage,
                limit: this.pageSize,
                batchId:this.$route.query.batchId//批次id
            }
            getloadTaxData({
                param: JSON.stringify(params)
            }).then(res=>{
                if(res.data.code==0) {
                    this.tableData = res.data.data.dataList
                    this.total = parseInt(res.data.data.total)
                    this.$emit('tableData',this.tableData, res.data.data.sum)
                }
            })
        },
        /**
         * @description 页面切换
         */
        handleCurrentChange(v) {
            this.currentPage = v
            this._getloadTaxData()
        },
        handleChangeInputSelect(v) {
            this.currentPage = 1
            this._getloadTaxData()
        },
        handleSelectionChange(row) {
            this.multipleSelection = row;
            this.$emit('selectChange',row)
        },
        updateRTableData() {
            this.currentPage = 1
        },
        handleSizeChange(val) {
            this.pageSize = val;
            console.log(`每页 ${val} 条`);
             this._getloadTaxData()
        },
    }

}

</script>

<style lang='scss'>
.payApvlRTable .el-pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 0;
    padding: 10px 5px;
    .el-pager li { border: none !important; }
    .el-pagination__editor.el-input .el-input__inner { height: 24px; }
}

.payApvlRTable .el-table  {
    th > .cell { height: auto; }
    thead .own-cancal--lh div { line-height: 0; padding: 0; }
    .own-cancal--lh .el-select div { padding: 0; }
    .own-cancal--lh { padding: 10px; }
}
.payApvlRTable .el-table__body-wrapper{
    min-height: 350px !important;
}

</style>
